import React from 'react';
import { Link } from 'react-router-dom';
import { DISCORD_URL } from '../../config';
import styles from './Footer.module.css';

const FOOTER_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'Story', to: '/story' },
  { label: 'Download', to: '/download' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Account', to: '/account' },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <span className={styles.logo}>Lineage II Community</span>
          <p className={styles.tagline}>Reawaken the Legend</p>
        </div>

        <nav className={styles.nav} aria-label="Footer navigation">
          <ul className={styles.linkList}>
            {FOOTER_LINKS.map(({ label, to }) => (
              <li key={to}>
                <Link to={to} className={styles.link}>{label}</Link>
              </li>
            ))}
            <li>
              <a
                href={DISCORD_URL}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.link}
              >
                Discord
              </a>
            </li>
          </ul>
        </nav>
      </div>

      <div className={styles.divider} />

      <div className={styles.bottom}>
        <p className={styles.copy}>
          &copy; {year} Lineage II Community. All rights reserved.
        </p>
        <p className={styles.disclaimer}>
          This is a private fan server. Not affiliated with NCSoft or Lineage II.
        </p>
      </div>
    </footer>
  );
}
